
export const permissionTitleStyles = {
  fontWeight: '300',
  lineHeight:'1.5em',
  fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',
  display:'inline-block'
};

